import React from "react";
import { motion } from "framer-motion";

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "300px",
        flexDirection: "column",
        gap: "1.5rem",
      }}
    >
      {/* Double ring loader */}
      <div style={{ position: "relative", width: "48px", height: "48px" }}>
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1.2, repeat: Infinity, ease: "linear" }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            border: "2px solid rgba(139,92,246,0.15)",
            borderTopColor: "#8b5cf6",
            borderRightColor: "#3b82f6",
          }}
        />
        <motion.div
          animate={{ rotate: -360 }}
          transition={{ duration: 0.8, repeat: Infinity, ease: "linear" }}
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            border: "2px solid rgba(59,130,246,0.15)",
            borderBottomColor: "#3b82f6",
            borderLeftColor: "#06b6d4",
          }}
        />
      </div>

      <motion.p
        animate={{ opacity: [0.5, 1, 0.5] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        style={{
          background: "linear-gradient(135deg, #8b5cf6, #3b82f6)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: "0.9rem",
          fontWeight: "600",
          margin: 0,
          letterSpacing: "0.5px",
        }}
      >
        Loading...
      </motion.p>
    </div>
  );
};

export default Loader;
